import { getDefinedUrlParams } from "@libs/utils";
import { ServiceBase } from "services/base-service";
import type { Language, LanguageUpdate, LanguageSummary, ValidationRules } from "features/languages/types";
import type { IPageableList, IPageableRequest } from "types";

class LanguagesService extends ServiceBase {
  constructor() {
    super();

    this.baseUrl = `${this.baseUrl}/Languages`;

    this.getLanguages = this.getLanguages.bind(this);
    this.deleteLanguage = this.deleteLanguage.bind(this);
  }

  async getLanguages(
    request: IPageableRequest,
    abortController?: AbortController,
  ): Promise<IPageableList<LanguageSummary>> {
    const params = {
      page: request.page,
      pageSize: request.pageSize,
      orderBy: request.orderBy,
      descendingOrder: request.descendingOrder,
    };

    const url = `?${getDefinedUrlParams(params)}`;
    const response = await this.sendGet(url, abortController);

    return response;
  }

  async getLanguage(id: string, abortController?: AbortController): Promise<Language> {
    const url = `/${id}`;
    const response = await this.sendGet(url, abortController);

    return response;
  }

  async saveLanguage(language: LanguageUpdate, abortController?: AbortController): Promise<{ id: string }> {
    const response = await this.sendPut("", language, abortController);

    return response;
  }

  async deleteLanguage(id: string, abortController?: AbortController): Promise<string> {
    const url = `/${id}`;
    const response = await this.sendDelete(url, abortController);

    return response;
  }

  async getGetValidationRules(abortController?: AbortController): Promise<ValidationRules> {
    const url = `/GetValidationRules`;
    const response = await this.sendGet(url, abortController);

    return response;
  }
}

const languagesService = new LanguagesService();

export { languagesService };
